export const WAIT_CONFIRMS = 5;

export function getRefreshTime(network) {
    return (network === "mainnet" ? 5 : 1) * 60 * 1000;
    // return 1 * 60 * 1000; // mainnetでも1分毎に更新
}
